import * as React from 'react';

import ResearchNav from './nav';

// import config from '@/server/config';
// import request from '@/server/request';

export default class AnalysisEdit extends React.Component { 
    public state = {

    }

    public componentDidMount() { 

    }

    public render() { 
        return (
            <section>
                <ResearchNav index={1} />
            </section>
        )
    }
}